<div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
    <div class="rounded-t border-b-2 mb-0 p-6">
      <div class="text-center flex justify-between">
        <h6 class="text-primary text-lg font-bold"> درخواست های مالی </h6>
        <button class="bg-primary text-white rounded pb-2 pt-1 px-3 text-base" (click)="modal.open()"> + درخواست جدید </button>
      </div>
    </div>

    <div class="flex flex-wrap pt-6">
        <div class="w-full lg:w-3/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-sm font-bold mb-2"> وضعیت </label>
              <select class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 border-gray-300 rounded text-sm w-full">
                <option value="null">---</option>
                <option value="1"> در انتظار شارژ کیف پول </option>
                <option value="2"> واریز بانک </option>
                <option value="3"> برداشت درصد سایت </option>
                <option value="4"> پرداخت مستقیم </option>
                <option value="5"> برداشت از کیف پول </option>
                <option value="6"> لغو ویزیت </option>
                <option value="7"> واریز پول نقد توسط ادمین </option>
                <option value="8"> خطا در تراکنش </option>
              </select>
            </div>
        </div>
        <!-- <div class="w-full lg:w-3/12 px-4">
            <div class="relative w-full mb-3"><label htmlfor="grid-password"
                    class="block uppercase text-blueGray-600 text-sm font-bold mb-2"> تاریخ </label><input type="text"
                    class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 border-gray-300 rounded text-sm focus:outline-none w-full">
            </div>
        </div> -->
    </div>

    <div class="flex-auto p-4">
        <div class="relative w-full overflow-x-auto rounded-md">
          <table class="w-full bg-transparent border-collapse">
            <thead class="bg-primary text-white">
              <tr>
                <th
                  class="align-middle border border-solid p-4 text-base border-l-0 border-r-0 font-semibold" >
                  تاریخ ثبت
                </th>
                <th class="align-middle border border-solid p-4 text-base border-l-0 border-r-0 font-semibold"  >
                  مقدار
                </th>
                <th class="align-middle border border-solid p-4 text-base border-l-0 border-r-0 font-semibold" >
                  زمان تسویه
                </th>
                <th class="align-middle border border-solid p-4 text-base border-l-0 border-r-0 font-semibold" >
                  نوع درخواست
                </th>
                <th class="align-middle border border-solid p-4 text-base border-l-0 border-r-0 font-semibold" >
                  وضعیت درخواست
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-b" *ngFor="let req of requestList">
                <td class="border-t-0 align-middle text-sm p-4">
                   {{(req.creatAt|shamsiDate)}}
                </td>
                <td class="border-t-0 align-middle text-sm p-4">
                    {{req.price}}
                </td>
                <td class="border-t-0 align-middle text-sm p-4" >
                {{req.timeType==1?'متنی':req.timeType==2?'آنی':null}}
                </td>
                
                <td class="border-t-0 align-middle text-sm p-4">
                   {{req.type==1?'در انتظار شارژ کیف پول ':req.type==2?'واریز بانک':req.type==3?'برداشت درصد سایت':req.type==4?'پرداخت مستقیم':
                   req.type==5?'برداشت از کیف پول':req.type==6?'لغو ویزیت':req.type==7?'واریز پول نقد توسط ادمین':req.type==8?'خطا در تراکنش':null}}
                </td>
                <td class="border-t-0 align-middle text-sm p-4">
                   {{req.status==0?'در انتظار تایید':req.status==1?'تایید شده':req.status==3?'درخواست جدید':req.status==2?'رد شده':null}}
                </td>
              </tr>
              
              
            </tbody>
          </table>
          </div>
    </div>
</div>
    

<p-toast dir="rtl"></p-toast>

<!-- MODAL SECTION -->

<app-modal #modal>
  <!--header-->
  <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
    <h3 class="text-xl font-semibold" style="margin-inline-end: 16rem;">
      ثبت درخواست
    </h3>
    <button
      class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
      (click)="modal.close()">
      <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
        ×
      </span>
    </button>
  </div>
  <!--body-->
  <div class="relative py-2 flex-auto">
    <div class="flex flex-wrap text-right">


      <div class="w-full p-2">
          <div class="relative w-full mb-3">
              <label class="block text-blueGray-600 text-sm font-bold mb-2">
                  زمان تسویه
              </label>
              <select  [(ngModel)]="cashReqInp.timeType"
                  class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm border-gray-300 w-full" >
                    <option [value]="2"> آنی </option>
              </select>
          </div>
      </div>
      <div class="w-full p-2">
          <div class="relative w-full mb-3">
              <label class="block text-blueGray-600 text-sm font-bold mb-2">
                   مقدار
              </label>
              <input type="number" [(ngModel)]="cashReqInp.price"
                  class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
          </div>
      </div>
  </div>
  </div>
  <!--footer-->
  <div class="flex items-center justify-between py-2 border-solid border-blueGray-200 rounded-b">
    <button
      class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150"
      type="button" (click)="modal.close();">
      انصراف
    </button>
    <button
      class="bg-primary text-white active:bg-red-500 font-bold text-sm px-6 py-2 rounded shadow hover:shadow-lg my-2 ease-linear transition-all duration-150"
      type="button" (click)="sendRequest()">
      تایید
    </button>
  </div>
</app-modal>